import * as React from "react";
import { forwardRef } from "react";
const SvgCoursesicon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentcolor", "data-token-category": "Navigation", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 16V0H16V16H0ZM15 15V8.5H8.5V15H15ZM15 1H8.5V7.5H15V1ZM1 1V7.5H7.5V1H1ZM1 15H7.5V8.5H1V15Z" }));
const ForwardRef = forwardRef(SvgCoursesicon);
export default ForwardRef;
